import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function PlayoffsStep({ eventData, setEventData }) {
  return (
    <div className="space-y-6 wizard-step">
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
        <div>
          <Label className="text-slate-700 font-medium">Enable Playoffs</Label>
          <p className="text-sm text-slate-500">Add elimination playoffs after round robin</p>
        </div>
        <Switch data-testid="enable-playoffs-switch" checked={eventData.playoffs.enabled}
          onCheckedChange={(checked) => setEventData(prev => ({ ...prev, playoffs: { ...prev.playoffs, enabled: checked } }))} />
      </div>

      {eventData.playoffs.enabled && (
        <div className="space-y-6 animate-fade-in-up">
          <div className="form-field">
            <Label className="text-slate-700 font-medium">Teams to Advance</Label>
            <Select value={eventData.playoffs.teams_advance.toString()}
              onValueChange={(value) => setEventData(prev => ({ ...prev, playoffs: { ...prev.playoffs, teams_advance: parseInt(value) } }))}>
              <SelectTrigger data-testid="teams-advance-select" className="mt-2 h-12"><SelectValue /></SelectTrigger>
              <SelectContent>
                {[2, 4, 8, 16].filter(n => n <= eventData.teams.length).map(n => (
                  <SelectItem key={n} value={n.toString()}>Top {n} teams</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="form-field stagger-1">
            <Label className="text-slate-700 font-medium">Playoff Format</Label>
            <RadioGroup value={eventData.playoffs.bracket_type}
              onValueChange={(value) => setEventData(prev => ({ ...prev, playoffs: { ...prev.playoffs, bracket_type: value } }))}
              className="mt-3 space-y-3">
              <Label htmlFor="single-bracket" data-testid="playoff-single"
                className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                  eventData.playoffs.bracket_type === 'single' ? 'border-[#00247D] bg-[#00247D]/5' : 'border-slate-200'
                }`}>
                <RadioGroupItem value="single" id="single-bracket" />
                <span className="font-medium">Single Elimination</span>
              </Label>
              <Label htmlFor="double-bracket" data-testid="playoff-double"
                className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                  eventData.playoffs.bracket_type === 'double' ? 'border-[#00247D] bg-[#00247D]/5' : 'border-slate-200'
                }`}>
                <RadioGroupItem value="double" id="double-bracket" />
                <span className="font-medium">Double Elimination</span>
              </Label>
            </RadioGroup>
          </div>

          <div className="form-field stagger-2">
            <Label className="text-slate-700 font-medium">Seeding Method</Label>
            <Select value={eventData.playoffs.seeding_method}
              onValueChange={(value) => setEventData(prev => ({ ...prev, playoffs: { ...prev.playoffs, seeding_method: value } }))}>
              <SelectTrigger data-testid="seeding-method-select" className="mt-2 h-12"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="record">Win/Loss Record</SelectItem>
                <SelectItem value="head_to_head">Head-to-Head</SelectItem>
                <SelectItem value="point_diff">Point Differential</SelectItem>
                <SelectItem value="manual">Manual Seeding</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
            <Label className="text-slate-700 font-medium">Consolation Bracket</Label>
            <Switch data-testid="consolation-switch" checked={eventData.playoffs.consolation_bracket}
              onCheckedChange={(checked) => setEventData(prev => ({ ...prev, playoffs: { ...prev.playoffs, consolation_bracket: checked } }))} />
          </div>
        </div>
      )}
    </div>
  );
}
